var $68ac86749db4c0fb$exports = {};
$68ac86749db4c0fb$exports = {
  "ascending": "vzestupn\u011B",
  "ascendingSort": function ascendingSort(args) {
    return "\u0159azeno vzestupn\u011B podle sloupce ".concat(args.columnName);
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " pixel\u016F");
  },
  "descending": "sestupn\u011B",
  "descendingSort": function descendingSort(args) {
    return "\u0159azeno sestupn\u011B podle sloupce ".concat(args.columnName);
  },
  "resizerDescription": "Stisknut\xEDm kl\xE1vesy Enter za\u010Dnete m\u011Bnit velikost",
  "select": "Vybrat",
  "selectAll": "Vybrat v\u0161e",
  "sortable": "sloupec s mo\u017Enost\xED \u0159azen\xED"
};
export { $68ac86749db4c0fb$exports as default };